import { mapErrors, ErrorMap } from "@/api/mapErrors";
import { useMemo } from "react";

export function useErrorMap(error: any): ErrorMap {
  return useMemo(() => mapErrors(error), [error]);
}
